import React from 'react';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { ICustomInspectionTypeFrontEndSettings } from '../../ICustomInspectionTypeFrontEndSettings';
import { SurveyEditAoBasisgegevensDecomposition } from './SurveyEditAoBasisgegevensDecomposition';

const tabNames = {
    summaryAndAdvice: 'summaryAndAdvice',
    decomposition: 'decomposition',
};

function Nothing(): JSX.Element | null {
    return null;
}

function SurveyEditPage(
    props: { tabName: string; surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    switch (props.tabName) {
        case tabNames.decomposition:
            return <SurveyEditAoBasisgegevensDecomposition {...props} />;
        case tabNames.summaryAndAdvice:
            return null;
        default:
            return <h1>Unknown tab &quot;${props.tabName}&quot;</h1>;
    }
}

export const aoBasisgegevensFrontEndSettings: ICustomInspectionTypeFrontEndSettings = {
    tabNames,

    surveyEditTabs: [
        { name: tabNames.decomposition, text: 'Decompositie' },
        { name: tabNames.summaryAndAdvice, textTranslateKey: 'survey.summaryAndAdviceTab' },
    ],
    surveyEditDefaultTabName: tabNames.decomposition,
    objectTreeDefaults: { filterOnElementGroups: false },
    objectTreeOptions: { archiveLinkAvailable: false, hasElementsGroups: false },
    showDocuments: false,

    getSurveyDetailsLeftTrayListItems: Nothing,
    getSurveyDetailsScrollMenuItems: Nothing,
    getSurveyEditSummaryAndAdvice: Nothing,
    getDecompositionElementAddEdit: Nothing,
    getDecompositionUnitAddEdit: Nothing,
    getSurveyDetailsComponents: Nothing,
    getSurveyEditPage: SurveyEditPage,

    showObjectTree: (tabName: string) => [tabNames.decomposition].includes(tabName),
    showLabelInSurveysMap: false,
};
